var req = require("!!/app/node_modules/pug-loader/index.js??ref--12-1!/app/src/esn.calendar.libs/app/components/freebusy/confirmation-modal/event-freebusy-confirmation-modal.pug");
module.exports = (req['default'] || req).apply(req, [])